import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';

export default function BuildingSitesListSkeleton({count = 7}) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        width: '100%',
        margin: '0 auto',
        padding: 2,
      }}
    >
      {[...Array(count)].map((_, index) => (
        <Skeleton
          key={index}
          variant="rectangular"
          width="100%"
          height={50}
          animation="wave"
        />
      ))}
    </Box>
  );
}